import { Link } from 'react-router-dom'
import { AppShell } from '../components/AppShell'
import { useAuth } from '../lib/auth'

function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  return new Date(iso).toLocaleString('en-IE', {
    weekday: 'short', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
  })
}

export function ClosedView() {
  const { account } = useAuth()
  return (
    <AppShell page="dashboard" showBalance={false} breadcrumb={<span className="topbar__breadcrumb-current">Account closed</span>}>
      <div className="empty-state" style={{ marginTop: 'var(--space-6)' }}>
        <div className="empty-state__icon" style={{ color: 'var(--color-danger)' }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <circle cx="12" cy="12" r="9" />
            <path d="M9 9 l6 6 M15 9 l-6 6" />
          </svg>
        </div>
        <h2 className="empty-state__title">Account closed</h2>
        <p className="empty-state__body">
          Reason: <strong style={{ color: 'var(--text-primary)' }}>{account?.closeReason ?? 'unknown'}</strong>
        </p>
        <p style={{ fontSize: 'var(--text-xs)', color: 'var(--text-tertiary)' }}>
          Closed at {fmtDateTime(account?.closedAt)}
        </p>
        <div style={{ marginTop: 'var(--space-4)', display: 'flex', gap: 'var(--space-2)' }}>
          <Link to="/onboarding" className="btn btn--primary" style={{ textDecoration: 'none' }}>Start a new challenge</Link>
          <Link to="/help" className="btn btn--ghost" style={{ textDecoration: 'none' }}>Contact support</Link>
        </div>
      </div>
    </AppShell>
  )
}
